/**
 * 모바일에서 막을 화면 목록.
 *
 * 라우터 가드와 사이드바 메뉴가 **같은 목록**을 봐야 한다.
 * 한쪽만 막으면 메뉴에는 보이는데 누르면 튕기는 상태가 된다.
 *
 * 고르는 기준은 「많이 잘리는데 우리가 고칠 수 없는 갈래」다.
 * 375px 실측에서 100px 이상 잘리면서, 원인이 다른 팀 파일 안에 있어 우리가 손댈 수 없는 것들이다.
 * 표가 길다거나 드래그가 있다는 것은 기준이 되지 못했다 — 컬럼 36개짜리도 실측에서는 깨끗했다.
 *
 * 갈래(경로 앞부분) 단위로 막는다. 화면 단위로 하면 목록이 길어지고 화면이 늘 때마다 손봐야 한다.
 */
export const MOBILE_BLOCKED_PREFIXES = [
    // 이벤트 — /events/add 783px, /events/dashboard 135px
    '/events',
    // 이벤트 V2 — review-summary 405px, attendee-segment-raw 240px, report 65px
    '/events-v2',
    // 프로모션 — create 222px, :id/edit 249px. 파일이 4,419줄이다
    '/promotions',
    // 브랜드 설정 — main 자체가 105px 넘친다. 파일이 3,079줄이다
    '/brand-settings',
    // 알림톡 — 원래도 privileges 로 막혀 있다. 목록에 명시만 한다
    '/alimtalk',
    // 이메일 템플릿 — 부여 계정이 0개라 아무도 못 들어간다
    '/email-templates',
];

/**
 * 경로가 그 갈래에 속하는지.
 *
 * 앞부분만 비교하면 `/event-crm` 이 `/events` 에 걸리는 식의 오판이 난다.
 * 경로 구분자까지 보고 판단한다 — `/events-v2` 는 `/events` 의 하위가 아니므로 목록에 따로 넣어 두었다.
 */
const isUnder = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

/**
 * 이 경로를 모바일에서 막아야 하는가.
 * 라우터 가드와 메뉴 필터가 함께 쓴다.
 */
export const isBlockedOnMobile = (path) => {
    if (!path) return false;
    // 쿼리·해시가 붙어 들어와도 경로만 본다
    const clean = path.split('?')[0].split('#')[0];
    return MOBILE_BLOCKED_PREFIXES.some((prefix) => isUnder(clean, prefix));
};
